import { LobbyScene } from './LobbyScene';
import { GameConstants } from './../../GameConstants';
import { GameVars } from "../../GameVars";
import { AudioManager } from '../../AudioManager';
import { GameManager } from '../../GameManager';
import * as Anuto from "../../../engine/src";

export class FirstBuyTutorialLayer extends Phaser.GameObjects.Container {

    public tutorialHand: Phaser.GameObjects.Image;

    private turretImg: Phaser.GameObjects.Image;
    private priceText: Phaser.GameObjects.Text;
    private buyBtn: Phaser.GameObjects.Image;

    constructor(scene: Phaser.Scene) {

        super(scene);

        this.alpha = 0;
        this.scaleX = GameVars.scaleX;

        const background = new Phaser.GameObjects.Graphics(this.scene);
        background.fillStyle(0x000000);
        background.fillRect(0, 0, GameConstants.GAME_WIDTH / GameVars.scaleX, GameConstants.GAME_HEIGHT);
        background.alpha = .45;
        this.add(background);

        this.tutorialHand = new Phaser.GameObjects.Image(this.scene, 332, 273, "texture_atlas_1", "hand-cursor");
        this.tutorialHand.setAngle(270);
        this.tutorialHand.setScale(1.5);
        this.add(this.tutorialHand); 

        this.createButton();

        this.scene.tweens.add({
            targets: [this.buyBtn, this.priceText],
            scaleX: 1.05,
            scaleY: 1.05,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 500,
            repeat: -1,
            yoyo: true
        });

        this.scene.tweens.add({
            targets: this.tutorialHand,
            x: this.tutorialHand.x + 10,
            ease: Phaser.Math.Easing.Linear,
            duration: 400,
            repeat: -1,
            yoyo: true
        });

        this.scene.tweens.add({
            targets: this,
            alpha: 1,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 1000
        });
    }

    public createButton(): void {

        let buttonContainer = new Phaser.GameObjects.Container(this.scene);
        buttonContainer.setPosition(68 + 128, 220);
        this.add(buttonContainer);

        let bck = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "tower_file");
        buttonContainer.add(bck);

        let turretName = new Phaser.GameObjects.Text(this.scene, 0, -52,  GameVars.turretsData[Anuto.GameConstants.TURRET_MORTAR].name.toUpperCase(), {fontFamily: "Rubik-Medium", fontSize: "15px", color: "#563744", align: "center"});
        turretName.setWordWrapWidth(100);
        turretName.setLineSpacing(-4);
        turretName.setOrigin(.5);
        buttonContainer.add(turretName);

        let upgrade = GameVars.gameData.upgradesUnlocked[Anuto.GameConstants.TURRET_MORTAR];

        this.turretImg = new Phaser.GameObjects.Image(this.scene, 0, -5, "texture_atlas_2", "tower_image_2_" + (upgrade === 0 ? 1 : upgrade));
        this.turretImg.setInteractive();
        this.turretImg.on("pointerover", () => {
            // 
        }, this);
        this.turretImg.on("pointerout", () => {
            // 
        }, this);
        this.turretImg.setScale(.85);
        buttonContainer.add(this.turretImg);

        this.buyBtn = new Phaser.GameObjects.Image(this.scene, 0, 55, "texture_atlas_1", "btn_buy");
        this.buyBtn.setInteractive();
        this.buyBtn.on("pointerdown", this.onClickBuy, this);
        this.buyBtn.on("pointerover", () => {
            this.buyBtn.setScale(1.05); 
            this.priceText.setScale(1.05); 
        }, this);
        this.buyBtn.on("pointerout", () => {
            this.buyBtn.setScale(1); 
            this.priceText.setScale(1); 
        }, this);
        buttonContainer.add(this.buyBtn);

        this.priceText = new Phaser.GameObjects.Text(this.scene, 0, 53,  GameVars.turretsData[Anuto.GameConstants.TURRET_MORTAR].buy[GameVars.gameData.upgradesUnlocked[Anuto.GameConstants.TURRET_MORTAR]], {fontFamily: "Dalek", fontSize: "20px", color: "#7E4D19", align: "center"});
        this.priceText.setOrigin(.5);
        buttonContainer.add(this.priceText);
    }

    public onClickBuy(): void {

        GameManager.buyUpgradeTurret(Anuto.GameConstants.TURRET_MORTAR);
        LobbyScene.currentInstance.upgradesLayer.updateInfo();

        this.destroy();

        AudioManager.playSound("buy_tower_upgrade");
    }
}
